import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useEquipmentData } from '../hooks/useEquipmentData';

export const EquipmentContext = createContext();

export const EquipmentProvider = ({ children }) => {
  const {
    equipmentData,
    tablesData,
    pendingCreations,
    pendingChanges,
    loading,
    error,
    fetchEquipmentData,
    fetchTablesData,
    fetchPendingCreationsData,
    fetchPendingChangesData,
    refreshData,
    isWardsCustomer,
    getAccessContext
  } = useEquipmentData();

  // Context value
  const contextValue = {
    // Data
    equipmentData,
    tablesData,
    pendingCreations,
    pendingChanges,
    
    // State
    loading,
    error,
    
    // Actions
    fetchEquipmentData,
    fetchTablesData,
    fetchPendingCreationsData,
    fetchPendingChangesData,
    refreshData,
    
    // Access control
    isWardsCustomer,
    
    // Context and debugging
    getAccessContext
  };

  return (
    <EquipmentContext.Provider value={contextValue}>
      {children}
    </EquipmentContext.Provider>
  );
};

// Custom hook to use the equipment context
export const useEquipment = () => {
  const context = useContext(EquipmentContext);
  
  if (!context) {
    throw new Error('useEquipment must be used within an EquipmentProvider');
  }
  
  return context;
};

export default EquipmentContext;
